/**
 * @fileoverview Composition of Experiences routes.
 *
 * This module aggregates route arrays for the different Experiences modules
 * (Rhomtrip and Ventrata) and exports them as a single array to be consumed
 * by the application's router configuration.
 */

import experiencesRhomtripRouters from '../modules/rhomtrip/router/experiences.rhomtrip.routers';
import experiencesVentrataRouters from '../modules/ventrata/router/experiences.ventrata.routers';

/**
 * Experiences route definitions.
 *
 * These routes are lazy-loaded and intended to be used as children of the
 * authenticated layout. Each route exposes a `meta` object with common
 * properties used by navigation guards and permission checks.
 *
 * @typedef {Object} ExperienceRouteMeta
 * @property {Array<string>} modules - Application module keys related to the route.
 * @property {boolean} requiresAuth - When true the route requires an authenticated session.
 * @property {Array<string>} roles - Array of role identifiers allowed to access the route.
 *
 * @type {Array<import('vue-router').RouteConfig>}
 */
export default [
    ...experiencesRhomtripRouters,
    ...experiencesVentrataRouters
]